import React, { useEffect, useState } from 'react'
import TitlebarAction from '../common/TitlebarActions'
import { CompanyForm } from '../../models/company.model'
import { getCompany } from '../../services/company.service'
import CompanyCreateForm from '../CompanyCreateForm'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import CompanyAreasListing from './CompanyAreasListing'
import { useProject } from '../../context/ProjectContext'
import { useNotification } from '../../context/NotificationContext'


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface CompanyViewProps {
  company_code: string,
  setBlockScreen: (p: any) => void,
  setSuccessMessage: () => void,
  tab?: number
}

const CompanyView: React.FC<CompanyViewProps> = ({
  company_code,
  setBlockScreen,
  setSuccessMessage,
  tab = 0
}) => {
    const { selectedProject } = useProject();
    const { showNotification } = useNotification();
    
    const [value, setValue] = useState(tab)
    const [name, setName] = useState<string>('')

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    }

    const [companyForm, setCompanyForm] = useState<CompanyForm>({
      name: '',
      code: '',
      created_date: '',
      phone_number: '',
      description: '',
    })

    const initComponent = () => {
      setBlockScreen(true);
      Promise.all([getCompany(selectedProject, company_code)]).then(function (results) {
        setCompanyForm(results[0]);
        setBlockScreen(false);
      setName(results[0].name);
      }).catch((error) => {
        showNotification(error.response.data)
        setBlockScreen(false);
      });
      setBlockScreen(false)
    }

    useEffect(initComponent, []);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
      setCompanyForm({
        ...companyForm,
        [event.target.name]: event.target.value
      });
    }

    return (<>
      <TitlebarAction title={`Compañía: ${name}`} />

      <Box sx={{ marginX: '1vw' }}>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value}
            onChange={handleTabChange}
            variant='scrollable'
            allowScrollButtonsMobile
          >
            <Tab label="DETALLE" {...a11yProps(0)} />
            <Tab label={`AREAS (${companyForm.areas_count})`} {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>

          <CompanyCreateForm
            companyForm={companyForm}
            company_code={company_code}
            setBlockScreen={setBlockScreen}
            handleChange={handleChange}
            setSuccessMessage={setSuccessMessage}
            action='view'
          />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <CompanyAreasListing setBlockScreen={setBlockScreen} company_code={company_code} />
        </CustomTabPanel>

      </Box>
    </>);
}

export default CompanyView